import { Component, inject, OnInit } from '@angular/core';
import { UntypedFormGroup, ReactiveFormsModule, FormsModule } from '@angular/forms';

import { MatCard, MatCardHeader, MatCardContent } from '@angular/material/card';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { UserService } from '../../../shared/services/user.service';
import { Globals } from '../../../shared/models/globals';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.css'],
    imports: [MatCard, MatCardHeader, MatCardContent, ReactiveFormsModule, FormsModule, MatFormField, MatLabel, MatInput, MatIcon, MatSuffix, MatButton]
})
export class ResetPasswordComponent  {

  loginForm: UntypedFormGroup;
  requestSuccess: boolean = false;
  requestError: boolean = false;

  UserService: UserService = inject(UserService); 
  _globals: Globals = inject(Globals);



  forgotPassword(UserName: string){
    //console.log(Email);
    this.UserService.forgotPassword(UserName).subscribe(
      {
        next: (v) => (this.requestSuccess=true),
        error: (e)=> (this.requestError=true),
        complete: () => (this.requestSuccess=true)
      }
    );

  }

}
